<style>
.fc-timegrid-event-harness {
    visibility: initial !important;
}
@media (max-width: 600px) {
    .fc-button {
        margin-bottom: 4px !important;
    }
}
</style>

<template>
    <div>
        <app-section-loader :status="calendar_loader"></app-section-loader>
        <full-calendar :options="calendarOptions" ref="calendar">
            <template slot="eventContent" slot-scope="{ timeText, event }">
                <v-layout row wrap class="fc-sticky fc-event-title" v-if="mode == 'schedule'">
                    <v-flex xs12 pl-1 fw-bold>
                        {{ timeText }}
                    </v-flex>
                    <v-flex column xs6 pt-1 pl-2 align-self-start>
                        <span>{{ event.extendedProps.name }}</span>
                        <span>{{ event.extendedProps.company }}</span>
                        <span>{{ event.extendedProps.pattern_number }}</span>
                    </v-flex>
                    <v-flex column xs6 pt-1 align-self-start>
                        <span>{{ event.extendedProps.customer_part_number }}</span>
                        <span>Qty {{ event.extendedProps.batch_qty }}</span>
                        <span>{{ event.extendedProps.batch_count }} {{ event.extendedProps.batch_count == "1" ? "Batch" : "Batches" }}</span>
                    </v-flex>
                </v-layout>
                <v-layout row wrap class="fc-sticky fc-event-title" v-else>
                    <v-flex xs12 pt-1 d-inline-flex>
                        <b class="pl-1">{{ timeText }}</b>
                        <span class="text-center">{{ event.extendedProps.batch_control_id }}</span>
                        <span class="text-right pr-1">Qty {{ event.extendedProps.batch_size }}</span>
                    </v-flex>
                    <v-flex xs12 pt-0 pl-2 d-inline-flex>
                        <span>{{ event.extendedProps.name }}</span>
                        <span class="text-right pr-1">{{ event.extendedProps.current_station }}</span>
                    </v-flex>
                    <v-flex xs12 pt-0 pl-2 d-inline-flex>
                        <span>{{ event.extendedProps.customer_part_number }}</span>
                        <span class="text-right pr-1" v-if="event.extendedProps.qc_flag == '1'"><v-icon large>flag</v-icon></span>
                    </v-flex>
                </v-layout>
            </template>
        </full-calendar>
        <bc-dialog :value="calendar_event_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline" v-if="current_event"
                        >{{
                            current_event.event.start.toLocaleTimeString([], {
                                timeZone: current_user ? current_user.user_time_zone : "America/New_York",
                                hour: "numeric",
                                minute: "numeric",
                            })
                        }}
                        -
                        {{
                            current_event.event.end.toLocaleTimeString([], {
                                timeZone: current_user ? current_user.user_time_zone : "America/New_York",
                                hour: "numeric",
                                minute: "numeric",
                            })
                        }}</span
                    >
                    <span class="headline" v-else>Not Scheduled</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="calendar_event_dialog"
                        :dialog-status="calendar_event_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text class="pa-0">
                    <v-layout row wrap class="pb-3 px-2">
                        <v-flex xs6 align-self-start>
                            <span class="fs-14">{{ $t("lang.part_name") }}</span>
                            <h3>{{ current_event_props.name ? current_event_props.name : "---" }}</h3>
                        </v-flex>
                        <v-flex xs6 align-self-start>
                            <span class="fs-14">{{ $t("lang.customer_part_number") }}</span>
                            <h3>{{ current_event_props.customer_part_number ? current_event_props.customer_part_number : "---" }}</h3>
                        </v-flex>
                        <v-flex xs6 align-self-start>
                            <span class="fs-14">{{ $t("lang.company") }}</span>
                            <h3>{{ current_event_props.company ? current_event_props.company : "---" }}</h3>
                        </v-flex>
                        <v-flex xs6 align-self-start>
                            <span class="fs-14">{{ $t("lang.batch_qty") }}</span>
                            <h3>{{ current_event_props.batch_qty ? current_event_props.batch_qty + " Qty" : "---" }}</h3>
                        </v-flex>
                        <v-flex xs6 align-self-start>
                            <span class="fs-14">{{ $t("lang.pattern_number") }}</span>
                            <h3>{{ current_event_props.pattern_number ? current_event_props.pattern_number : "---" }}</h3>
                        </v-flex>
                        <v-flex xs6 align-self-start>
                            <span class="fs-14">{{ $t("lang.batch_count") }}</span>
                            <h3>
                                {{
                                    current_event_props.batch_count
                                        ? current_event_props.batch_count + (current_event_props.batch_count == "1" ? " Batch" : " Batches")
                                        : "---"
                                }}
                            </h3>
                        </v-flex>
                    </v-layout>
                    <v-layout row class="border-bottom-2" :style="!$bp.smallScreen ? 'max-height: 525px;' : ''" v-if="current_event_props.work_orders_batches">
                        <v-flex xs12 pa-0 :style="!$bp.smallScreen ? 'overflow: auto' : ''">
                            <v-data-table
                                :headers="headers"
                                :items="current_event_props.work_orders_batches"
                                item-key="batch_id"
                                :no-data-text="$t('lang.no_results_matching')"
                                hide-actions
                            >
                                <template slot="items" slot-scope="props">
                                    <tr class="clickable" @click="goToBatch(props.item)">
                                        <td class="text-center">
                                            <bc-tooltip top>
                                                <template slot="activator">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        @click.stop="
                                                            dev_mode
                                                                ? showPrinter(props.item.batch_id, 'print_4x6_label')
                                                                : printLabel(props.item.batch_id, 'print_4x6_label')
                                                        "
                                                    >
                                                        <v-icon>label</v-icon>
                                                    </v-btn>
                                                </template>
                                                Print Label
                                            </bc-tooltip>
                                            <bc-tooltip top>
                                                <template slot="activator">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        @click.stop="
                                                            dev_mode
                                                                ? showPrinter(props.item.batch_id, 'print_process_sheet')
                                                                : printLabel(props.item.batch_id, 'print_process_sheet')
                                                        "
                                                    >
                                                        <v-icon>description</v-icon>
                                                    </v-btn>
                                                </template>
                                                Print Process Sheet
                                            </bc-tooltip>
                                        </td>
                                        <td class="px-1 text-center">{{ props.item.batch_control_id }}</td>
                                        <td class="px-1 text-center">{{ props.item.batch_size ? props.item.batch_size : "" }}</td>
                                        <td class="px-1 text-center">{{ props.item.start }}</td>
                                        <td class="px-1 text-center">{{ props.item.current_station }}</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions v-if="mode == 'schedule'">
                    <v-btn
                        color="error"
                        @mouseup.left="$refs.unscheduleDialog.openDialog()"
                        v-if="current_event && current_event_props.has_completed_furnace == '0' && hasPerm('scheduling.delete')"
                        >Unschedule</v-btn
                    >
                    <v-btn color="error" @mouseup.left="$refs.deleteDialog.openDialog()" v-else-if="!current_event && hasPerm('scheduling.delete')"
                        >Delete</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <v-dialog ref="dialog" v-model="select_date_dialog" :return-value="select_date" persistent lazy full-width width="290px">
            <v-date-picker v-model="select_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="select_date_dialog = false">Cancel</v-btn>
                <v-btn
                    color="primary"
                    :disabled="$route.query.start_date ? convertTimestampToDate($route.query.start_date) == select_date : false"
                    @click="customButtonAction('gotoDate')"
                >
                    OK
                </v-btn>
            </v-date-picker>
        </v-dialog>
        <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
        <delete-confirmation-dialog
            ref="unscheduleDialog"
            :headline="$t('lang.unschedule')"
            :message="$t('lang.confirm_unschedule_header')"
            @onConfirm="onUnscheduleConfirm"
        ></delete-confirmation-dialog>
        <delete-confirmation-dialog
            ref="deleteDialog"
            :headline="$t('lang.delete')"
            heading="Are you sure you want to delete this work order and all of it's batches?"
            message="This action will return all quantities back to the warehouse."
            @onConfirm="onDeleteConfirm"
        ></delete-confirmation-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import "@fullcalendar/core/vdom"; // solves prob
import FullCalendar from "@fullcalendar/vue";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { toMoment } from "@fullcalendar/moment"; // only for formatting
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import AppConfig from "Constants/AppConfig";

import app from "Main";

export default {
    components: {
        FullCalendar, // make the <FullCalendar> tag available
    },
    props: {
        data_object: {
            type: String,
            default: "work_orders",
        },
        event_url: {
            type: String,
            default: "work_orders/continuous/schedule",
        },
        editable: {
            type: Boolean,
            default: true,
        },
        furnace: {
            type: String,
            default: null,
        },
        mode: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            select_date_dialog: false,
            select_date: null,
            headers: [
                { text: "", align: "center", sortable: false, width: "20%" },
                { text: this.$t("lang.control_id"), value: "batch_control_id", align: "center" },
                { text: this.$t("lang.qty"), value: "batch_size", align: "center" },
                { text: this.$t("lang.start"), value: "start", align: "center" },
                { text: this.$t("lang.current_station"), value: "current_station", align: "center" },
            ],
            calendar_refreshed: false,
            calendar_loader: false,
            file_name: null,
            test: false,
            calendar_event_dialog: false,
            current_event: null,
            current_event_props: {},
            calendarOptions: {
                slotEventOverlap: false,
                contentHeight: 800,
                headerToolbar: {
                    left: "prevButton,nextButton todayButton",
                    center: "title",
                    right: "datepickerButton timeGridDay,timeGridThreeDay",
                },
                plugins: [interactionPlugin, timeGridPlugin, momentTimezonePlugin],
                initialView: "timeGridThreeDay",
                views: {
                    timeGridThreeDay: {
                        type: "timeGrid",
                        duration: { days: 3 },
                        buttonText: "3 day",
                        dateIncrement: { days: 1 },
                    },
                },
                events: this.getEvents,
                allDaySlot: false,
                // slotMinTime: '08:00:00',
                timeZone: app.current_user ? app.current_user.user_time_zone : "America/New_York",
                slotDuration: "00:15:00",
                snapDuration: "00:01:00",
                selectMirror: true,
                firstDay: 1,
                eventOverlap: true,
                editable: false,
                droppable: false, // this allows things to be dropped onto the calendar
                eventClick: this.handleEventClick,
                eventStartEditable: true,
                eventDurationEditable: false,
                duration: { days: 3 },
                nowIndicator: true,
                scrollTimeReset: false,
                scrollTime: this.setInitialOffset(),
                eventDrop: this.manageEventDrop,
                drop: this.manageDrop,
                eventDragStart: this.manageDragStart,
                customButtons: {
                    prevButton: {
                        icon: "chevron-left",
                        click: () => this.customButtonAction("prev"),
                    },
                    nextButton: {
                        icon: "chevron-right",
                        click: () => this.customButtonAction("next"),
                    },
                    todayButton: {
                        text: "today",
                        click: () => this.customButtonAction("today"),
                    },
                    datepickerButton: {
                        text: "select",
                        click: () => this.openDateSelect(),
                    },
                },
                initialDate: this.setInitialDate(),
            },
        };
    },
    mounted() {
        if (this.$route.query.start_date) {
            let calendar_headers = {
                left: "prevButton,nextButton todayButton",
                center: "title",
                right: "datepickerButton timeGridDay,timeGridThreeDay",
            };
            if (this.$bp.xsOnly) calendar_headers.right = "datepickerButton timeGridDay";
            if (this.$refs.calendar) this.$refs.calendar.getApi().setOption("headerToolbar", calendar_headers);
            if (this.$bp.xsOnly && this.$refs.calendar) this.$refs.calendar.getApi().changeView("timeGridDay");
            if (this.select_date == null) this.select_date = this.convertTimestampToDate(this.$route.query.start_date);
        }
    },
    computed: {
        full_url() {
            return AppConfig.baseApiUrl + `/${this.event_url}`;
        },
    },
    methods: {
        openDateSelect() {
            this.select_date_dialog = true;
        },
        getEvents(info, successCallback, failureCallback) {
            // let furnace = this.$route.query && this.$route.query.furnace ? this.$route.query.furnace : false;
            // if(!this.$route.query.start_date || !this.$route.query.end_date){
            //     console.log(this.$route.query)
            //     this.$router.replace({ name: this.$route.name, query: { furnace_option: this.furnace, start_date: info.start.valueOf() / 1000, end_date: info.end.valueOf() / 1000 } })
            //     successCallback({})
            //     return
            // }

            if (this.event_url && this.furnace && this.$route.query.start_date) {
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: this.event_url,
                        method: "get",
                        body: {
                            start_date: info.start.valueOf() / 1000,
                            end_date: info.end.valueOf() / 1000,
                            editable: this.editable,
                            furnace: this.furnace,
                        },
                    })
                    .then((data) => {
                        if (this.$refs.calendar) this.$refs.calendar.getApi().removeAllEvents();
                        if (data[this.data_object]) {
                            if (this.calendar_refreshed) {
                                this.createAlert("success", "page_refreshed");
                                this.calendar_refreshed = false;
                            }
                            successCallback(data[this.data_object]);
                        } else {
                            failureCallback();
                        }
                    });
            } else {
                successCallback({});
            }
        },
        refreshEvents(status = true) {
            this.$nextTick(() => {
                this.$refs.calendar.getApi().refetchEvents();
                this.calendar_refreshed = status;
            });
        },
        handleEventClick: function (info) {
            if (this.mode == "schedule") {
                this.calendar_event_dialog = true;
                this.current_event = info;
                // console.log(info)
                let event = info.event;
                this.current_event_props = { ...info.event.extendedProps };
                // console.log(this.current_event_props)
                if (this.current_event_props && !this.current_event_props.work_orders_batches) {
                    this.$store.commit("toggleModalLoader", true);
                    this.$store
                        .dispatch("fetchWorkOrder", {
                            url: `work_orders/continuous/${this.current_event_props.work_order_id}`,
                            method: "get",
                        })
                        .then((data) => {
                            if (data && data.work_order) {
                                event.setExtendedProp("work_orders_batches", data.work_order.work_orders_batches || []);
                                this.current_event_props.work_orders_batches = data.work_order.work_orders_batches || [];
                            }
                            this.$store.commit("toggleModalLoader", false);
                        });
                }
            } else {
                this.goToBatch(info.event.extendedProps);
            }
        },
        openUnscheduled(event) {
            this.current_event_props = event;
            this.current_event = null;
            this.calendar_event_dialog = true;
        },
        onDeleteConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/continuous/${this.current_event_props.work_order_id}`,
                    method: "delete",
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$refs.deleteDialog.close();
                        this.calendar_event_dialog = false;
                        this.refreshEvents(false);
                        this.getUnscheduled();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        onUnscheduleConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/continuous/${this.current_event.event.extendedProps.work_order_id}/unschedule`,
                    method: "delete",
                })
                .then((data) => {
                    if (data && data.code == "200") {
                        this.$refs.unscheduleDialog.close();
                        this.calendar_event_dialog = false;
                        this.refreshEvents(false);
                        this.getUnscheduled();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        manageEventDrop(drop_info) {
            // event was moved
            let event_props = drop_info.event.extendedProps;
            let start_time = drop_info.event.start.getTime() / 1000;
            this.modifyWorkOrder(event_props, drop_info, start_time);
        },
        manageDrop(drop_info) {
            // event was dropped
            let event_props = JSON.parse(drop_info.draggedEl.attributes.getNamedItem("data-event").value);
            let start_time = drop_info.date.getTime() / 1000;
            this.modifyWorkOrder(event_props, drop_info, start_time, true);
            this.$store.commit("mutateWorkOrder", {
                property: "unscheduled_work_orders",
                method: "delete",
                id: event_props.work_order_id,
                pk: "work_order_id",
            });
        },
        setInitialOffset(offset_value = 2) {
            let start_time = new Date();
            if (start_time.getHours() > 2) {
                start_time.setTime(start_time.getTime() - offset_value * 60 * 60 * 1000);
            }
            start_time = start_time.toLocaleTimeString("en-US", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                hour12: false,
                hour: "2-digit",
                minute: "2-digit",
            });
            let hours = +start_time.split(":")[0];
            // if adjusted time wraps to previous day, set to midnight
            if (hours >= 24 - offset_value && hours < 25) {
                let adjust_time = new Date();
                adjust_time.setTime(adjust_time.getTime() - (offset_value - (24 - hours)) * 60 * 60 * 1000);
                start_time = adjust_time.toLocaleTimeString("en-US", {
                    timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                    hour12: false,
                    hour: "2-digit",
                    minute: "2-digit",
                });
                if (+start_time.split(":")[0] >= 24 - offset_value) {
                    start_time = "00:00";
                }
            }
            start_time = `${+start_time.split(":")[0]}:00`;
            return start_time;
        },
        getUnscheduled() {
            this.$store.dispatch("fetchWorkOrder", {
                url: "work_orders/continuous",
                method: "get",
                stateProperty: "unscheduled_work_orders",
                dataProperty: "work_orders",
                commit: true,
                body: { scheduled: 0, furnace_option: this.furnace },
            });
        },
        modifyWorkOrder(work_order, drop_info, start_time, refresh_unscheduled = false) {
            if (this.mode == "schedule") {
                let view_start = drop_info.view.activeStart.getTime() / 1000;
                let view_end = drop_info.view.activeEnd.getTime() / 1000;

                let work_order_id = work_order.work_order_id;
                this.calendar_loader = true;
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `work_orders/continuous/${work_order_id}/${view_start}/${view_end}/${this.furnace}`,
                        method: "patch",
                        stateProperty: "work_orders",
                        patch: true,
                        body: { start: start_time },
                    })
                    .then((data) => {
                        if (data && data.code == 200) {
                            if (this.$refs.calendar) {
                                let calendar = this.$refs.calendar.getApi();
                                calendar.removeAllEvents();
                                calendar.addEventSource(data[this.data_object]);
                            }
                        } else {
                            this.refreshEvents(false);
                        }
                        if (refresh_unscheduled) this.getUnscheduled();
                        this.calendar_loader = false;
                    });
            }
        },
        printLabel(batch_id, type) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batches/${type}`,
                    method: "get",
                    body: {
                        batch_id: batch_id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.$refs.print.printReport(data.process_sheet.file_name);
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.$refs.print.printReport(data.bill_of_lading.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        showPrinter(batch_id, type) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batches/${type}`,
                    method: "get",
                    body: {
                        batch_id: batch_id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.file_name = data.process_sheet.file_name;
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.file_name = data.bill_of_lading.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        goToBatch(batch) {
            this.$router.push({ name: "batch_profile", params: { work_order_id: batch.work_order_id, batch_id: batch.batch_id } });
        },
        getView() {
            if (this.$refs.calendar) {
                return this.$refs.calendar.getApi().view;
            } else {
                return "";
            }
        },
        getApi() {
            if (this.$refs.calendar) {
                return this.$refs.calendar.getApi();
            } else {
                return "";
            }
        },
        customButtonAction(action) {
            let one_day = 60 * 60 * 24;
            if (this.$refs.calendar) {
                let cal_api = this.$refs.calendar.getApi();
                let current_start = cal_api.view.currentStart.getTime() / 1000;
                let new_start_date = null;

                if (action == "next") {
                    new_start_date = current_start + one_day;
                } else if (action == "prev") {
                    new_start_date = current_start - one_day;
                } else if (action == "today") {
                    let today_unix =
                        new Date(
                            new Date().toLocaleString("en-US", { timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York" })
                        ).setHours(0, 0, 0, 0) / 1000;
                    new_start_date = today_unix;
                } else if (action == "gotoDate") {
                    // 'gotoDate' puts the date in the middle if three day view, adjust start_date by one day
                    new_start_date = this.convertDateToTimestamp(this.select_date) + one_day * 2;
                    this.select_date_dialog = false;
                }
                // for 'gotoDate' pass along date, other actions dont have parameter
                cal_api[action](new_start_date * 1000);

                this.$nextTick(() => {
                    this.$router.push({
                        name: this.$route.name,
                        query: {
                            furnace_option: this.$route.query.furnace_option ? this.$route.query.furnace_option : null,
                            start_date: new_start_date,
                        },
                        params: {
                            loader: false,
                        },
                    });
                    // udpate date picker if other button is used
                    if (action != "gotoDate") {
                        this.select_date = this.convertTimestampToDate(new_start_date);
                    }
                });
            }
        },
        setInitialDate() {
            return this.$route.query.start_date * 1000;
        },
        convertTimestampToDate(timestamp) {
            return new Date(timestamp * 1000).toLocaleDateString("fr-CA", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        convertDateToTimestamp(date) {
            let new_date = new Date(
                new Date(date).toLocaleDateString("fr-CA", { timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York" })
            ).setHours(0, 0, 0, 0);
            return new_date / 1000;
        },
        manageDragStart(info) {
            // console.log('manageDragStart')
            // console.log(info)
            // info.event.setStart(1646827200000, { maintainDuration:true })
            // console.log(info)
        },
    },
    watch: {
        furnace: function (newVal, oldVal) {
            this.refreshEvents(false);
        },
        "$bp.xs": function (newVal, oldVal) {
            if (this.$refs.calendar) {
                let calendar_headers = {
                    left: "prevButton,nextButton todayButton",
                    center: "title",
                    right: "datepickerButton timeGridDay,timeGridThreeDay",
                };
                if (newVal) {
                    calendar_headers.right = "datepickerButton timeGridDay";
                    this.$refs.calendar.getApi().changeView("timeGridDay");
                } else {
                    this.$refs.calendar.getApi().changeView("timeGridThreeDay");
                }
                this.$refs.calendar.getApi().setOption("headerToolbar", calendar_headers);
            }
        },
    },
};
</script>
